/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very good within each solvent's fitted range; near the extremes of that range the estimate drifts, so treat edge cases as approximate.`)
};

const es_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy buena dentro del rango ajustado de cada disolvente; cerca de los extremos de ese rango la estimación se desvía, así que trata los casos límite como aproximados.`)
};

const de_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innerhalb des angepassten Bereichs jedes Lösungsmittels sehr gut; nahe den Randbereichen weicht die Schätzung ab, solche Grenzfälle sollten daher als Näherung betrachtet werden.`)
};

const nl_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeer nauwkeurig binnen het gefitte bereik van elk oplosmiddel; nabij de uitersten van dat bereik wijkt de schatting af, dus beschouw randgevallen als benaderend.`)
};

const fr_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très bonne dans la plage ajustée de chaque solvant ; près des extrêmes de cette plage, l'estimation dérive, donc les cas limites doivent être considérés comme approximatifs.`)
};

const it_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molto accurata entro l'intervallo di adattamento di ciascun solvente; vicino agli estremi di tale intervallo la stima si discosta, quindi trattare i casi limite come approssimativi.`)
};

const pt_br2_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito boa dentro da faixa ajustada de cada solvente; perto dos extremos dessa faixa a estimativa se afasta, então trate os casos extremos como aproximados.`)
};

const pt_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito boa dentro do intervalo ajustado de cada solvente; perto dos extremos desse intervalo a estimativa perde precisão, pelo que os casos-limite devem ser tratados como aproximados.`)
};

const ja_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各溶媒のフィッティング範囲内では非常に精度が高いですが、その範囲の端に近づくと推定値がずれるため、境界付近の値は近似として扱ってください。`)
};

const zh_bp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在各溶剂的拟合范围内非常准确；接近该范围极限时估算会出现偏差，因此边缘情况应视为近似值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_faq_a3", locale)
	if (locale === "en") return en_bp_faq_a3(inputs)
	if (locale === "es") return es_bp_faq_a3(inputs)
	if (locale === "de") return de_bp_faq_a3(inputs)
	if (locale === "nl") return nl_bp_faq_a3(inputs)
	if (locale === "fr") return fr_bp_faq_a3(inputs)
	if (locale === "it") return it_bp_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_bp_faq_a3(inputs)
	if (locale === "pt") return pt_bp_faq_a3(inputs)
	if (locale === "ja") return ja_bp_faq_a3(inputs)
	return zh_bp_faq_a3(inputs)
};